import React from 'react'
import reactStringReplace from 'react-string-replace'

import { Link } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(() => ({
  root: {
    wordBreak: 'break-all',
    whiteSpace: 'pre-wrap',
  },
}))

const LinkUrlText: React.FC<{
  children: string
  className?: string
  urlMaxLength?: number
}> = ({ children, className, urlMaxLength = 30 }) => {
  const { classes, cx } = useStyles()

  if (!children) return null

  const lines = children.split('\n')
  const urlRegExp = /(h?ttps?:\/\/[a-zA-Z0-9.\-_@:/~?%&;=+#',()*!]+)/g
  const shortUrl = (string: string) =>
    string.length <= urlMaxLength
      ? string
      : `${string.slice(0, urlMaxLength)}...`

  return (
    <span className={cx(classes.root, className)}>
      {lines
        .map((line) =>
          reactStringReplace(line, urlRegExp, (match, i) => (
            <Link
              key={`${match}${i}`}
              href={match}
              target="_blank"
              rel="noopener noreferrer"
            >
              {shortUrl(match)}
            </Link>
          ))
        )
        .reduce((prev, curr) => [prev, '\n', curr])}
    </span>
  )
}

export default LinkUrlText
